module.exports = __webpack_public_path__ + "static/media/answerPage4.f041312b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPage4.png
// module id = 1726
// module chunks = 0 1